import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createNewOrder } from "./orderAPI";

const initialState = {
    status: "idle",
    currentOrderPlaced: null,
    tempOrder: null // Add tempOrder to the initial state
}

export const createNewOrderAsync = createAsyncThunk(
    'order/createNewOrder',
    async (order) => {
        const response = await createNewOrder(order);
        return response;
    }
)



export const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {
        resetCurrentOrder: (state) => {
            state.currentOrderPlaced = null
        },
        savedTempOrder: (state, action) => {
            state.tempOrder = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createNewOrderAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createNewOrderAsync.rejected, (state) => {
                state.status = 'succeeded';
            })
            .addCase(createNewOrderAsync.fulfilled, (state, action) => {
                if (action.payload.status === "success") {
                    state.status = 'succeeded';
                    state.currentOrderPlaced = action.payload.message
                }
            })
    }
});

export const { resetCurrentOrder, savedTempOrder } = orderSlice.actions

export const selectCurrentOrder = (state) => state.order.currentOrderPlaced;

export const selectTempOrder = (state) => state.order.tempOrder;

export default orderSlice.reducer;